<template>
  <div class="news-page">
    <div class="news-header">
      <ContainerCom contentId="news-header">
        <TextCom class="news-header-title" :contentId="'news-header-title'" />
        <!-- <div class="news-header-line"></div> -->
      </ContainerCom>
    </div>

    <div class="news-container">
      <!-- 新闻Banner轮播 -->
      <div class="news-banner-container">
        <NewsBanner :news-list="newsList" :interval="5000" :autoplay="true" />
      </div>
      <span class="news-more">{{ $t("news.moreNews") }}</span>
      <div class="news-list">
        <div
          v-for="news in newsList"
          :key="news.id"
          class="news-item"
          @click="goToNewsDetail(news.id, news.linkUrl)"
        >
          <div class="news-item-left">
            <img
              v-if="news.coverImage"
              :src="news.coverImage"
              :alt="news.title"
              class="news-cover-image"
            />
            <div v-else class="news-cover-placeholder"></div>
          </div>
          <div class="news-item-right">
            <h3 class="news-title">{{ news.title }}</h3>
            <p class="news-summary">{{ news.summary }}</p>
            <div class="news-meta">
              <span class="news-time"
                ><el-icon><Calendar /></el-icon
                >{{ formatDate(news.publishTime) }}</span
              >
            </div>
          </div>
        </div>
      </div>

      <!-- 加载状态 -->
      <div v-if="loading" class="loading-container">
        <div class="loading-spinner"></div>
        <p>{{ $t("news.loading") }}</p>
      </div>

      <!-- 无数据提示 -->
      <div v-else-if="newsList.length === 0" class="empty-container">
        <p>{{ $t("news.empty") }}</p>
      </div>
    </div>

    <!-- 分页 -->
    <!-- <div v-if="total > 0 && !loading" class="pagination">
      <el-pagination
        v-model:current-page="currentPage"
        v-model:page-size="pageSize"
        :page-sizes="[10, 20, 50]"
        layout="prev, pager, next"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div> -->
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import { ElMessage } from "element-plus";
import newsAPI from "../api/modules/news";
import ContainerCom from "../components/ContainerCom.vue";
import NewsBanner from "../components/NewsBanner.vue";
import TextCom from "../components/TextCom.vue";

export default {
  name: "News",
  components: {
    ContainerCom,
    NewsBanner,
    TextCom,
  },
  setup() {
    const { t } = useI18n();
    const router = useRouter();
    const newsList = ref([]);
    const bannerNewsList = ref([]);
    const loading = ref(false);
    const currentPage = ref(1);
    const pageSize = ref(999);
    const total = ref(0);

    // 获取新闻列表
    const fetchNewsList = async () => {
      loading.value = true;
      try {
        // 在实际环境中调用API
        const response = await newsAPI.getNewsList({
          page: currentPage.value,
          pageSize: pageSize.value,
        });
        newsList.value = response.data.list || [];
        total.value = response.data.total || 0;
      } catch (error) {
        ElMessage.error($t("admin.error.fetchFailed"));
      } finally {
        loading.value = false;
      }
    };

    // 格式化日期
    const formatDate = (dateString) => {
      if (!dateString) return "";
      const date = new Date(dateString);
      return date.toLocaleDateString("zh-CN", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
    };

    // 跳转到新闻详情或外部链接
    const goToNewsDetail = (newsId, linkUrl) => {
      // 如果存在linkUrl，则直接跳转到外部链接
      if (linkUrl) {
        window.open(linkUrl, "_blank");
      } else if (newsId) {
        // 否则使用路由跳转到详情页
        router.push(`/news/${newsId}`);
      }
    };

    // 分页处理
    const handleSizeChange = (size) => {
      pageSize.value = size;
      fetchNewsList();
    };

    const handleCurrentChange = (current) => {
      currentPage.value = current;
      fetchNewsList();
    };

    // 组件挂载时获取数据
    onMounted(() => {
      fetchNewsList();
    });

    return {
      newsList,
      bannerNewsList,
      loading,
      currentPage,
      pageSize,
      total,
      formatDate,
      goToNewsDetail,
      handleSizeChange,
      handleCurrentChange,
    };
  },
};
</script>

<style scoped>
.news-page {
  min-height: 100vh;
  /* padding: 60px 0; */
  /* background-color: #fafafa; */
  background-color: rgb(236, 240, 244);
}
.news-header-title {
  /* 上下，左右居中 */
  position: absolute;
  left: 15%;
  top: 40%;
  transform: translate(-50%, -50%);
  font-size: 4rem;
  color: #fff;
  letter-spacing: 5px;
  /* 响应式设计 */
  @media (max-width: 1200px) {
    font-size: 3.5rem;
    left: 18%;
  }
  @media (max-width: 992px) {
    font-size: 3rem;
    left: 20%;
    top: 40%;
    letter-spacing: 4px;
  }
  @media (max-width: 768px) {
    font-size: 2.5rem;
    left: 25%;
    top: 40%;
    letter-spacing: 3px;
  }
  @media (max-width: 576px) {
    font-size: 2rem;
    left: 30%;
    top: 40%;
    letter-spacing: 2px;
  }
  @media (max-width: 480px) {
    font-size: 3rem;
    left: 50%; /* 修改为50%使标题在小屏幕时居中 */
    transform: translate(-50%, -50%); /* 配合left:50%实现水平居中 */
    top: 50%;
    letter-spacing: 1px;
    text-align: center;
  }
}
.news-header {
  text-align: center;
  /* position: absolute; */
  left: 0;
  top: 0px;
  width: 100vw;
  height: 60vh;
  z-index: 1;
  /* 响应式高度 */
  @media (max-width: 768px) {
    height: 50vh;
  }
  @media (max-width: 576px) {
    height: 40vh;
  }
  @media (max-width: 480px) {
    height: 30vh;
  }
}

/* 只为背景图片添加放大动画 */
.news-header :deep(.background-img) {
  animation: bgScaleUp 3s ease-out forwards;
}

@keyframes bgScaleUp {
  from {
    transform: scale(1);
  }
  to {
    transform: scale(1.05);
  }
}

.news-header-line {
  width: 80px;
  height: 4px;
  background-color: #1890ff;
  margin: 0 auto;
  border-radius: 2px;
}

.news-container {
  margin: 0 auto;
  padding: 0px 8vw;
  /* margin-top: 200px; */
  background-color: rgb(236, 240, 244);
  position: relative;
  z-index: 2;
  /* transform: translateY(500px); */
  padding-bottom: 80px;
  /* 响应式设计 */
  @media (max-width: 768px) {
    /* transform: translateY(400px); */
    padding: 0px 24px;
  }
  @media (max-width: 576px) {
    /* transform: translateY(300px); */
    padding: 0px 12px;
  }
  @media (max-width: 480px) {
    /* transform: translateY(200px); */
    padding: 0px 12px;
  }
}

.news-list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 40px;
  margin-top: 40px;
}

.news-item {
  display: flex;
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
  height: 280px;
  padding: 12px;
}

.news-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15);
}

.news-item-left {
  flex: 0 0 300px;
  position: relative;
  border-radius: 12px;
  overflow: hidden;
}

.news-cover-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform 0.5s ease;
}

.news-item:hover .news-cover-image {
  transform: scale(1.05);
}

.news-cover-placeholder {
  width: 100%;
  height: 100%;
  background-color: #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  font-size: 14px;
  background-image: linear-gradient(45deg, #f5f5f5 25%, transparent 25%),
    linear-gradient(-45deg, #f5f5f5 25%, transparent 25%),
    linear-gradient(45deg, transparent 75%, #f5f5f5 75%),
    linear-gradient(-45deg, transparent 75%, #f5f5f5 75%);
  background-size: 20px 20px;
  background-position: 0 0, 0 10px, 10px -10px, -10px 0px;
}

.news-item-right {
  flex: 1;
  padding: 30px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  overflow: hidden;
}

.news-title {
  font-size: 24px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 20px;
  line-height: 1.4;
  transition: color 0.3s ease;
}

.news-item:hover .news-title {
  color: #1890ff;
}

.news-summary {
  font-size: 16px;
  color: #666;
  line-height: 1.8;
  margin-bottom: 25px;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  /* 添加底部内边距，隐藏可能露出的文字 */
  padding-bottom: 2px;
  /* 确保容器高度能完全容纳3行文字 */
  max-height: calc(16px * 1.8 * 3 + 2px);
}

.news-meta {
  display: flex;
  align-items: center;
  gap: 20px;
}

.news-time {
  font-size: 14px;
  color: #999;
  display: flex;
  align-items: center;
  gap: 5px;
}

/* .news-time::before {
  content: "📅";
  font-size: 16px;
} */

.pagination {
  margin-top: 40px;
  display: flex;
  justify-content: center;
}
.news-more {
  font-size: 3rem;
  transition: color 0.3s ease;
  @media (max-width: 480px) {
    font-size: 2rem;
  }
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 100px 0;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid #f3f3f3;
  border-top: 3px solid #1890ff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 15px;
}

.empty-container {
  text-align: center;
  padding: 100px 0;
  color: #999;
}
.news-banner-container {
  transform: translateY(-75px);
  padding: 24px;
  height: 450px;
  background: #fff;
  border-radius: 15px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .news-banner-container {
    transform: translateY(-75px);
    padding: 24px;
    height: 400px;
  }

  .news-list {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 992px) {
  .news-item {
    height: 180px;
  }

  .news-list {
    grid-template-columns: repeat(1, 1fr);
    gap: 30px;
  }

  .news-item-left {
    flex: 0 0 200px;
  }

  .news-item-right {
    padding: 20px;
  }

  .news-title {
    font-size: 20px;
    margin-bottom: 15px;
  }

  .news-summary {
    font-size: 14px;
    -webkit-line-clamp: 2;
    max-height: calc(14px * 1.8 * 2 + 2px);
    padding-bottom: 2px;
  }
}

@media (max-width: 768px) {
  .news-page {
    padding: 0 0 40px 0;
  }
  .news-banner-container {
    transform: translateY(-75px);
    padding: 24px;
    height: 800px;
  }
  .news-header {
    margin-bottom: 40px;
  }

  .news-list {
    grid-template-columns: 1fr;
    gap: 25px;
  }

  .news-item {
    flex-direction: column;
    height: auto;
  }

  .news-item-left {
    flex: none;
    height: 280px;
    width: 100%;
  }

  .news-item-right {
    padding: 20px;
  }

  .news-title {
    font-size: 20px;
    margin-bottom: 15px;
  }

  .news-summary {
    font-size: 14px;
    -webkit-line-clamp: 2;
    margin-bottom: 15px;
    max-height: calc(14px * 1.8 * 2 + 2px);
    padding-bottom: 2px;
  }

  .news-meta {
    gap: 15px;
  }

  .pagination {
    margin-top: 30px;
  }

  .loading-container,
  .empty-container {
    padding: 60px 0;
  }
}

@media (max-width: 480px) {
  .news-page {
    padding: 0px 0 30px 0;
  }

  .news-header {
    margin-bottom: 30px;
  }

  .news-item-left {
    height: 160px;
  }

  .news-item-right {
    padding: 15px;
  }

  .news-title {
    font-size: 18px;
  }

  .news-time {
    font-size: 13px;
  }
}
</style>
